import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { LimitOrder } from "#/types/orders";

export const optionLimitOrderTypeAtom = atomWithStorage<LimitOrder>(
  "optionLimitOrderType",
  LimitOrder.GTC,
);

export const useOptionLimitOrderType = () => {
  const [optionLimitOrderType, setOptionLimitOrderType] = useAtom(
    optionLimitOrderTypeAtom,
  );

  return {
    optionLimitOrderType,
    setOptionLimitOrderType,
  };
};
